import React from "react";

const AccessDenied = ({
  message = "You don't have permission to view this.",
  className = "h-full flex items-center justify-center text-[#64748B]",
  children,
}) => {
  return <div className={className}>{children ?? message}</div>;
};

export default AccessDenied;
